<svg
    xmlns="http://www.w3.org/2000/svg"
    {...$$props}
    width="17"
    height="16"
    fill="none"
    ><path
        fill="#fff"
        fill-rule="evenodd"
        d="M8.43 2.617A5.367 5.367 0 0 0 3.047 8a5.367 5.367 0 0 0 5.383 5.383A5.367 5.367 0 0 0 13.813 8v-.466h1.5V8a6.867 6.867 0 0 1-6.883 6.883A6.867 6.867 0 0 1 1.547 8 6.867 6.867 0 0 1 8.43 1.117c1.401 0 2.692.37 3.77 1.14l-.872 1.22c-.79-.564-1.766-.86-2.898-.86Zm6.797 1.58L8.894 10.53c-.24.24-.548.32-.797.32s-.558-.08-.797-.32l-2.2-2.2 1.06-1.06 1.937 1.936 6.07-6.07 1.06 1.061Z"
        clip-rule="evenodd"
    /></svg
>
